<template>
  <transition
    v-bind="$attrs"
    :name="name"
    @enter="enter"
    @after-enter="afterEnter"
    @leave="leave"
  >
    <slot></slot>
  </transition>
</template>

<script>
  /**
   * Functional component to animate content 'height' between 'auto' and '0'.
   */
  export default {
    name: 'c-transition-expand',
    inheritAttrs: false,

    props: {
      name: {
        type: String,
        default: 'transition-expand',
      },
    },

    methods: {
      afterEnter(element) {
        element.style.height = 'auto';
      },

      enter(element) {
        const { width } = getComputedStyle(element);

        element.style.width = width;
        element.style.position = 'absolute';
        element.style.visibility = 'hidden';
        element.style.height = 'auto';

        const { height } = getComputedStyle(element);

        element.style.width = null;
        element.style.position = null;
        element.style.visibility = null;
        element.style.height = 0;

        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        getComputedStyle(element).height;

        requestAnimationFrame(() => {
          element.style.height = height;
        });
      },

      leave(element) {
        const { height } = getComputedStyle(element);

        element.style.height = height;

        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        getComputedStyle(element).height;

        requestAnimationFrame(() => {
          element.style.height = 0;
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  * {
    transform: translateZ(0);
    backface-visibility: hidden;
    perspective: 1000px;
    will-change: height;
  }
</style>

<style lang="scss">
  .transition-expand-enter-active,
  .transition-expand-leave-active {
    overflow: hidden;
    transition: height 200ms ease-in-out;
  }

  .transition-expand-enter-from,
  .transition-expand-leave-to {
    height: 0;
  }
</style>
